var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9985 13.3408C14.2068 13.3408 15.997 11.5506 15.997 9.34225C15.997 7.13394 14.2068 5.34375 11.9985 5.34375C9.79019 5.34375 8 7.13394 8 9.34225C8 11.5506 9.79019 13.3408 11.9985 13.3408Z",
    fill: "#A7B7DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2668 6.76151C21.7164 4.23644 18.1897 0 12 0C5.81027 0 2.28358 4.23644 0.733158 6.76151C-0.244386 8.34262 -0.244386 10.3404 0.733158 11.9216C2.28358 14.4467 5.81027 18.6831 12 18.6831C18.1897 18.6831 21.7164 14.4467 23.2668 11.9216C24.2443 10.3404 24.2443 8.34262 23.2668 6.76151ZM12 15.3393C8.68752 15.3393 6.0022 12.654 6.0022 9.34153C6.0022 6.02907 8.68752 3.34376 12 3.34376C15.3124 3.34376 17.9978 6.02907 17.9978 9.34153C17.9944 12.6526 15.3111 15.336 12 15.3393Z",
    fill: "#A7B7DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye1);
export default __webpack_public_path__ + "static/media/eye (1).47f6e75794b08f48734072f4ee311273.svg";
export { ForwardRef as ReactComponent };